import styled from 'styled-components';

export const Exp = styled.div`
    padding-top:70px;
    background-color: #1D1E22;

    @media screen and (max-width: 550px){
        padding-top:60px;

    }
    `;

export const ExploreContainer = styled.div`
    background-color:#1D1E22;
    height:100%;
    padding:40px;

    @media screen and (max-width: 750px){
        padding: 20px;
    }
`;

export const Container = styled.div`
    max-width:1200px;
    min-height:100vh;
    margin: 0 auto;
  `;